module.exports = __webpack_public_path__ + "img/nathalie_de_loeper_praticienne_shiatsu.12152383.jpg";